import { SharedState } from '$utils/sharedState.svelte';

class StateGnosisPayOnboardingStarted extends SharedState<boolean> {}

export const stateGnosisPayOnboardingStarted = new StateGnosisPayOnboardingStarted(false, {
  persistence: { key: 'gnosisPayOnboardingStarted' },
});
